export const accordionData = [
  {
    title: 'Name, occupation, contact details',
    details: (
      <div>
        This includes:
        <ul>
          <li>Names</li>
          <li>Occupation</li>
          <li>Phone</li>
          <li>Email address</li>
          <li>Mail address</li>
          <li>Residential address</li>
        </ul>
      </div>
    ),
  },
  {
    title: 'Account balance and details',
    details: (
      <div>
        This includes:
        <ul>
          <li>Name of account</li>
          <li>Type of account</li>
          <li>Account balance</li>
          <li>Account number</li>
          <li>Interest rates</li>
          <li>Fees</li>
          <li>Discounts</li>
          <li>Account terms</li>
          <li>Account mail address</li>
        </ul>
      </div>
    ),
  },
  {
    title: 'Transaction details',
    details: (
      <div>
        This includes :
        <ul>
          <li>Incoming and outgoing transactions</li>
          <li>Amounts</li>
          <li>Dates</li>
          <li>Descriptions of transactions</li>
          <li>
            Who you have sent money to and received money from; (e.g. their
            name)
          </li>
        </ul>
        <br></br>This may include historical data that dates back to 1 January
        2017.
      </div>
    ),
  },
]
